import { getEmpresaIdContexto } from "roboflex-thalamus-request-handler";

const DISPOSITIVO_STORAGE_PREFIX = "dispositivoSelecionado";

/** Chave de sessionStorage do dispositivo selecionado, escopada por empresa. */
export function getDispositivoStorageKey() {
  const empresaId = getEmpresaIdContexto();
  return `${DISPOSITIVO_STORAGE_PREFIX}:${empresaId ?? "none"}`;
}

export function limparDispositivoSelecionadoStorage() {
  if (typeof sessionStorage === "undefined") return;

  const keysToRemove = [];
  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i);
    if (key && (key === DISPOSITIVO_STORAGE_PREFIX || key.startsWith(`${DISPOSITIVO_STORAGE_PREFIX}:`))) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach((key) => sessionStorage.removeItem(key));
}
